import { SportEventData, TimelineData } from "../Timeline/Types";
import { GameTitle } from "./GameTimelineHeader.styles";

export function GameTimelineHeader({ timeline }: { timeline: TimelineData }) {
    const title =
        timeline.sportEvent.sportEventContext.dayName ??
        getEventName(timeline.sportEvent);

    return <GameTitle>{title}</GameTitle>;
}

const getEventName = (sportEventData: SportEventData) => {
    const sportEventRound = sportEventData.sportEventContext.round?.number;
    return `${sportEventData.sportEventContext.competition.name} ${
        sportEventRound
            ? `–
                    ${
                        Number.isInteger(sportEventRound)
                            ? `${sportEventRound}. Spieltag`
                            : `${sportEventRound
                                  ?.charAt(0)
                                  .toUpperCase()}${sportEventRound.slice(1)}`
                    }`
            : ""
    }`;
};
